/**
 * @description 입력받은 element의 형제 elements들 중 filter 조건에 부합하는 elements 리스트를 반환
 * @function getSibilings
 * @param {HTMLElement} element
 * @param {String} filter
 * @returns {Array}  filter 조건에 부합하는 element 리스트. 없다면 빈 배열 반환
 */
function getSiblings(element: HTMLElement, filter: String) {
  let matchesFn: any;

  ///
  /// 1. 벤더 리스트
  ///
  [
    "matches",
    "webkitMatchesSelector",
    "mozMatchesSelector",
    "msMatchesSelector",
    "oMatchesSelector"
  ].some(function(fn) {
    if (typeof (document.body as any)[fn] === "function") {
      matchesFn = fn;
      return true;
    }
    return false;
  });

  let parent: any = element.parentElement;
  let children = parent.children;
  let result = [];

  ///
  /// 2. filter 조건에 부합하는 형제 element 검색
  ///
  for (let i = 0; i < children.length; i++) {
    if (children[i][matchesFn](filter)) {
      result.push(children[i]);
    }
  }

  return result;
}

export { getSiblings };
